<template>
  <div class="live" :style="{ backgroundColor: backgroundColor }">
    <img class="image" :src="imageUrl" alt="" />
    <div
      class="btn"
      :style="{ backgroundColor: btnColor }"
      ref="copy"
      :data-clipboard-text="livePwd"
      @click="copyPwd"
    >
      <div class="text">{{ livePwd }}</div>
      <div class="copy">复制</div>
    </div>
  </div>
</template>
<script>
import Clipboard from 'clipboard'
import appApi from '@/common/app-common.js'
export default {
  data() {
    return {
      backgroundColor: '',
      imageUrl: '',
      btnColor: '',
      livePwd: ''
    }
  },
  created() {
    this.getQuery()
    console.log(this.$route)
  },
  mounted() {
    this.clipboard = new Clipboard(this.$refs.copy)
  },
  methods: {
    getQuery() {
      this.backgroundColor = this.$route.query.backColor
      this.imageUrl = this.$route.query.url
      this.btnColor = this.$route.query.btnColor
      this.livePwd = this.$route.query.live_password
      appApi.changeWebview({
        title: this.$route.query.live_title || '抖音直播'
      })
    },
    //复制口令
    copyPwd() {
      this.clipboard.on('success', () => {
        this.$toast('复制成功')
      })
      this.clipboard.on('error', () => {
        this.$toast('复制失败')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.live {
  min-height: 100vh;

  .image {
    width: 100%;
  }

  .btn {
    position: fixed;
    z-index: 1;
    left: 50%;
    bottom: 34px;
    transform: translate(-50%, 0%);
    width: 335px;
    background: #706de0;
    border-radius: 12px;
    padding: 12px 16px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 20px;
    text-align: center;
    display: flex;
    align-items: center;

    .text {
      flex: 1;
      flex-shrink: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .copy {
      position: relative;
      padding-left: 10px;
      margin-left: 10px;
    }
    .copy::after {
      content: '';
      width: 1px;
      height: 12px;
      background: rgba(255, 255, 255, 0.5);
      position: absolute;
      top: 50%;
      left: 0;
      transform: translate(0%, -50%);
    }
  }
}
</style>
